export type TranslationDict = Record<string, unknown>
export type TranslationNamespaceDict = Record<string, TranslationDict>

type LocaleModule = {
  default: TranslationDict
}

const BUILTIN_LOCALE_MODULES = import.meta.glob<LocaleModule>('./*/*.json', {
  eager: true,
})

function buildBuiltinDicts() {
  const out: Record<string, TranslationNamespaceDict> = {}

  for (const [modulePath, module] of Object.entries(BUILTIN_LOCALE_MODULES)) {
    const match = modulePath.match(/^\.\/([^/]+)\/([^/]+)\.json$/)
    if (!match) continue

    const [, locale, namespace] = match
    const localeDict = (out[locale] ??= {})
    localeDict[namespace] = module.default
  }

  return out
}

export const BUILTIN_DICTS = buildBuiltinDicts()

export const BUILTIN_NAMESPACES = Array.from(
  new Set(Object.values(BUILTIN_DICTS).flatMap((dict) => Object.keys(dict))),
).sort()

export function cloneTranslationDict<T>(dict: T): T {
  return JSON.parse(JSON.stringify(dict)) as T
}
